
import * as d3 from 'd3'

export default {

  data: () => ({
    pop: {
      width: 800,
      height: 800,
      bar: 30,
    },
  }),


  methods: {

    draw_Popup_Window(win, data_, _item) {

      this.canvasPopup = this.canvasForms
      .append('g')
      .attr('id', 'POPUP')
      .attr('transform', `translate(0, 0)`)
      .attr('font-family', 'roboto').attr('opacity', 1).attr('visibility', 'display')

      this.canvasPopup
      .append('rect')
      .attr('id', `background`)
      .attr('x', -.5).attr('y', -.5).attr('width', this.Canvas.CanvasWidth)
      .attr('height', this.Canvas.CanvasHeight).attr('fill', '#000').attr('opacity', .7)
      .on('click', () => {this.close_Popup()})

      // ### Modal Window ###
      let modal = this.canvasPopup
      .append('g')
      .attr('id', 'fixedGroup')
      .attr('transform', `translate(${this.header.width + 10}, ${150 + window.scrollY})`)

      // Filter Window
      modal
      .append('rect')
      .attr('x', 0).attr('y', 0)
      .attr('width', this.pop.width).attr('height', this.pop.height) .attr('rx', 2).attr('stroke', '#757575').attr('stroke-width', 1)
      .attr('fill', '#fff').attr('filter', 'url(#dropshadow)').attr('opacity', .5)

      // Window bar
      modal
      .append('rect')
      .attr('x', 0).attr('y', 0).attr('width', this.pop.width).attr('height', this.pop.bar)
      .attr('fill', 'url(#windowBar)')

      // Contents Window 
      modal
      .append('rect')
      .attr('x', 0).attr('y', this.pop.bar).attr('width', this.pop.width).attr('height', this.pop.height - this.pop.bar)
      .attr('fill', 'url(#contentWindow)')

      modal
      .append('line')
      .attr('x1', 0).attr('x2', this.pop.width)
      .attr('y1', this.pop.bar + 1).attr('y2', this.pop.bar + 1).attr('stroke', '#bcbcbc').attr('stroke-width', 0.5)

      modal
      .append('line')
      .attr('x1', 0).attr('x2', this.pop.width)
      .attr('y1', this.pop.bar + 2).attr('y2',this.pop.bar + 2).attr('stroke', '#fff').attr('stroke-width', 1)

      let close = modal
      .append('g')
      .attr('transform', `translate(${this.pop.width - 24}, 7)`)
      .attr('cursor', 'pointer').attr('opacity', 1)
      .on('mouseover', function() {d3.select(this).attr('opacity', .3)})
      .on('mouseout', function() {d3.select(this).transition().duration(200).attr('opacity', 1)})
      .on('click', () => {
        this.close_Popup()
      }) 

      close
      .append('rect')
      .attr('width', 16).attr('height', 16).attr('rx', 3).attr('fill', '#fff').attr('stroke', '#bcbcbc').attr('stroke-width', .5)
      
      close
      .append('line')
      .attr('x1', 4).attr('x2', 12).attr('y1', 4).attr('y2',12).attr('stroke', '#bcbcbc').attr('stroke-width', 1)
      close
      .append('line')
      .attr('x1', 4).attr('x2', 12).attr('y1', 12).attr('y2',4).attr('stroke', '#bcbcbc').attr('stroke-width', 1)

      let self_ = this
      d3.select(window)
        .on('scroll', function(event) {
        d3.select('#fixedGroup').attr('transform',`translate(${self_.header.width + 10}, ${150 + window.scrollY})`)
      })

      if (win == 'WorkOrder') this.popup_WorkOrder(modal, data_, _item)
      if (win == 'MenuItem') this.popup_MenuItem(modal, data_, _item)
    },




    close_Popup() {
      this.canvasPopup.transition().duration(500).attr('opacity', 0)
      this.canvasPopup.transition().duration(500).delay(500).attr('visibility', 'hidden')

      setTimeout(() => { 
        d3.select('#POPUP').remove()
      }, 500)
    },


  }
}